import { Link } from "react-router-dom";
import DownArrow from "../../SvgComponents/DownArrow";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

function PageWithSubpagesForMorePages(

    props: {
        page:any,
        index: number
    }

) {

    const page = props.page;
    const index = props.index;

    const [dropdown, setDropdown] = useState<boolean>(false);
    const [arrowAngle, setArrowAngle] = useState<number>(0);

    function activateDropdown() {
        setArrowAngle(180);
        setDropdown(true);
      }
    
      function deactivateDropdown() {
        setArrowAngle(0);
        setDropdown(false);
      }
  
      function toggleDropdown() {
          if(dropdown === false) {
              activateDropdown()
          }
          else if(dropdown === true) {
              deactivateDropdown()
          }
      }

  return (
    <div
        className="flex flex-col 
                    w-full"
    >
        <div
            className="flex items-center
                        w-full"
        >
            <Link
                // eslint-disable-next-line
                to={page.pageLink}
                key={index}
                className="p-4
                        flex items-center flex-1
                        text-white
                        bg-[#076ca6] hover:bg-[#075887]"
            >
                <p>
                {page.pageName}
                </p>
            </Link>
            <div
                onClick={toggleDropdown}
                className="w-[60px] h-[60px]
                            flex items-center justify-center
                            stroke-white
                            cursor-pointer
                            hover:bg-black/30"
            >
                <motion.div
                    animate={{
                        rotate: arrowAngle
                    }}

                >
                    <DownArrow />
                </motion.div>
            </div>
        </div>
        {
            dropdown && 
            <div
                className="flex flex-col"
            >
                {
                    page.subPages.map((subpage: any) => 
                        <Link
                        // eslint-disable-next-line
                        to={subpage.subPageLink}
                        key={index}
                        className="p-4
                                    flex items-center
                                    bg-blue-500 hover:bg-slate-400/60
                                    text-white
                                    pl-9"
                        onClick={() => {
                            deactivateDropdown();
                        }}
                        >
                            <p>
                            {subpage.subPageName}
                            </p>
                        </Link>
                    )
                }
            </div>
        }
    </div>
  )
}

export default PageWithSubpagesForMorePages